export default "__VITE_ASSET__v55SkLfGVmwHpn9ZTfa$yA__"